import { Message } from '@arco-design/web-react'
import { addFiles } from 'ACTIONS/image'
import { DefaultRootState } from 'react-redux'
import { FileItem, ImageType, Template } from 'REDUCERS/image'
import { takeLatest, select, put, call, retry } from 'redux-saga/effects'
import { getTemplateParams } from 'UTILS'
import getUrlByPath from 'UTILS/getUrlByPath'
import { SlardarEventType, staticArr, typeFileMap } from '~/constants'
import { getActiveUrl } from 'UTILS/getActiveUrl'
import { serviceQuality } from '@byted-vcloud/exp-lite-slardar'

import * as Apis from '~/service/imagex'

export async function computeImage(
  url: string,
): Promise<{ url: string; size: number; ok: boolean; demotion: string | null }> {
  const res = await fetch(url, {
    mode: 'cors',
  })
  const contentLength = res.headers.get('content-length')
    ? res.headers.get('content-length')
    : res.headers.get('x-length')
  const size = parseInt(contentLength || '0')
  const demotion = res.headers.get('imagex-demotion')
  //avif的降级不上报
  if (demotion !== 'avif') {
    serviceQuality({
      taskType: SlardarEventType.ImageDemotion,
      success: !demotion,
      customInfo: { url, size, ok: res.ok },
    })
  }
  return { url, size, ok: res.ok, demotion }
}

function* getCutImage() {
  const { template: t, imageList, active } = yield select(
    (state: DefaultRootState) => state.image.present,
  )
  const template = imageList[active]?.template ?? t
  const close = Message.info({ content: '图片获取中...', duration: 0 })
  const params = getTemplateParams(template)
  const type = imageList[active].type as ImageType
  const { compareIndex, files } = imageList[active]
  try {
    const templateName = (yield retry(3, 100, Apis.CreateImageTemplate, {
      ...params,
      ...{
        Filters: params.Filters.filter(
          (item) =>
            item.Name !== 'crop' && item.Name !== 'smartv2' && item.Name !== 'trimv2',
        ),
      },
    })).TemplateName
    const cutUrl = getUrlByPath(`${imageList[active].uid}~${templateName}`)
    const fileMap = typeFileMap[type]
    if (staticArr.includes(type)) {
      const url = cutUrl.replace('.image', `.${fileMap[compareIndex]}`)
      const { size } = yield call(computeImage, url)

      yield put(
        addFiles({
          files: [
            ...files,
            {
              type: 'cut',
              size,
              url,
            },
          ],
          index: active,
        }),
      )
    } else {
      const url = yield call(
        getActiveUrl,
        cutUrl.replace('.image', `.${fileMap[compareIndex]}`),
      )
      //当返回‘’时停止dispatch
      if (url === '') return
      const { size } = yield call(computeImage, url)
      yield put(
        addFiles({
          files: [
            ...files,
            {
              type: 'cut',
              size,
              url,
            },
          ],
          index: active,
        }),
      )
    }
  } catch (e) {
    Message.error({ content: '网络繁忙，请稍后重试' })
  } finally {
    close()
  }
}

function* getPreviewImages() {
  const { template: t, imageList, active } = yield select(
    (state: DefaultRootState) => state.image.present,
  )
  const template: Template = imageList[active]?.template ?? t
  const close = Message.info({ content: '图片处理中...', duration: 0 })
  const params = getTemplateParams(template)
  const type = imageList[active].type as ImageType
  const { compareIndex } = imageList[active]
  try {
    let files: FileItem[] = []
    const templateName = (yield retry(3, 100, Apis.CreateImageTemplate, params))
      .TemplateName
    const transUrl = getUrlByPath(`${imageList[active].uid}~${templateName}`)
    const fileMap = typeFileMap[type]
    if (staticArr.includes(type)) {
      const url = transUrl.replace('.image', `.${fileMap[compareIndex]}`)
      const { size, ok } = yield call(computeImage, url)
      const score =
        template.vqscore && ok
          ? (yield call(Apis.GetImageQuality, { ImageUrl: url })).NrScores
          : undefined
      const time = new Date().valueOf()
      for (const item of fileMap) {
        if (item === fileMap[compareIndex]) {
          files.push({
            type: item as ImageType,
            size,
            url,
            score,
            time,
          })
        } else {
          files.push({
            type: item as ImageType,
            size: 0,
            url: '',
          })
        }
      }
      yield put(addFiles({ files, index: active }))
      close()
      files = []
      for (const item of fileMap) {
        if (item === fileMap[compareIndex]) {
          files.push({
            type: item as ImageType,
            url,
            size,
            score,
            time,
          })
        } else {
          const url = transUrl.replace('.image', `.${item}`)
          const { size, ok } = yield call(computeImage, url)
          const score =
            template.vqscore && ok
              ? (yield call(Apis.GetImageQuality, { ImageUrl: url })).NrScores
              : undefined
          const file = {
            type: item,
            size,
            url,
            score,
            time: new Date().valueOf(),
          } as FileItem
          files.push(file)
        }
      }
      yield put(addFiles({ files, index: active }))
    } else {
      const url = yield call(
        getActiveUrl,
        transUrl.replace('.image', `.${fileMap[compareIndex]}`),
      )
      //当返回‘’时停止dispatch
      if (url === '') return
      const { size } = yield call(computeImage, url)
      const score = template.vqscore
        ? (yield call(Apis.GetImageQuality, { ImageUrl: url })).NrScores
        : undefined
      const time = new Date().valueOf()
      for (const item of fileMap) {
        if (item === fileMap[compareIndex]) {
          files.push({
            type: item as ImageType,
            url,
            size,
            score,
            time,
          })
        } else {
          files.push({
            type: item as ImageType,
            size: 0,
            url: '',
          })
        }
      }
      yield put(addFiles({ files, index: active }))
      close()
      files = []
      for (const item of fileMap) {
        if (item === fileMap[compareIndex]) {
          files.push({
            type: item as ImageType,
            size,
            url,
            score,
            time,
          })
        } else {
          let url = transUrl.replace('.image', `.${item}`)
          url = yield call(getActiveUrl, url)
          const score = template.vqscore
            ? (yield call(Apis.GetImageQuality, { ImageUrl: url })).NrScores
            : undefined
          if (url === '') return
          const { size } = yield call(computeImage, url)
          const file = {
            type: item,
            size,
            url,
            score,
            time: new Date().valueOf(),
          } as FileItem
          files.push(file)
        }
      }
      yield put(addFiles({ files, index: active }))
    }
  } catch (e) {
    Message.error({ content: '网络繁忙，请稍后重试' })
  } finally {
    close()
  }
}

function* getImage() {
  const { template: t } = yield select((state: DefaultRootState) => state.image.present)
  if (t.mode === 'cut') {
    yield call(getCutImage)
  } else {
    yield call(getPreviewImages)
  }
}

export default function* rootSaga() {
  yield takeLatest(['GET_PREVIEW_IMAGES', 'GET_CUT_IMAGE'], getImage) //获取处理后图片
}
